import { createResetStateMutation } from '@/helpers';
import { applySwitchToPlan } from '@/helpers/loteAdicionales';
import { getInitialStateAgro } from './state';

export const updateFormData = (state, updatedData) => {
   state.formData = state.formData.map((e) => {
      return e.id === updatedData.id ? updatedData : e;
   });
};

export const deleteFormData = (state, id) => {
   state.formData = state.formData.filter((e) => e.id !== id);
};

export const setData = (state, data) => {
   state.cultivos = data.valref;
   state.localidades = data.postal;
   state.monedas = data.moneda;
   state.pagos = data.fpago;
};

export const setCoordDibujo = (state, coords) => {
   state.coordDibujo = coords;
};
export const setSelectedPlan = (state, plan) => {
   state.selectedPlan = plan;
};

export const setCurrentLote = (state, dato) => {
   state.currentLote = dato;
};
export const setMonedaLiquidacion = (state, moneda) => {
   state.monedaLiquidacion = moneda;
};

export const setPlanes = (state, planes) => {
   state.planes = planes;
};

export const setTotalHa = (state, sumatoriaHectareas) => {
   state.sumatoriaHectareas = sumatoriaHectareas;
};

export const setFormasPago = (state, formasPago) => {
   state.formaPago = formasPago;
};

export const setCompaniasAgro = (state, cias) => {
   state.companias = cias;
};

export const updateLoteSwitch = (state, { loteId, switchType, value }) => {
   applySwitchToPlan(state.selectedPlan, loteId, switchType, value);
   (state.planes || []).forEach((plan) =>
      applySwitchToPlan(plan, loteId, switchType, value),
   );
};

export const setDescuentos = (state, descuentos) => {
   state.descuentos = descuentos;
};

export const setProvinciasCotizables = (state, provincias) => {
   state.provinciasCotizables = provincias || [];
};

export const setDepartamentosCotizables = (
   state,
   { id_provincia, departamentos },
) => {
   state.departamentosCotizables = {
      ...state.departamentosCotizables,
      [id_provincia]: departamentos || [],
   };
};

export const setDepartamentosCotizablesReset = (state) => {
   state.departamentosCotizables = {};
};

export const resetState = createResetStateMutation(getInitialStateAgro);
